export default __webpack_public_path__ + "static/media/behance.0f18b557.svg";